import { render, staticRenderFns } from "./complaint-lines-tab.vue?vue&type=template&id=2c6233ec&scoped=true"
import script from "./complaint-lines-tab.vue?vue&type=script&lang=js"
export * from "./complaint-lines-tab.vue?vue&type=script&lang=js"
import style0 from "./complaint-lines-tab.vue?vue&type=style&index=0&id=2c6233ec&prod&lang=scss&scoped=true"
import style1 from "./complaint-lines-tab.vue?vue&type=style&index=1&id=2c6233ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6233ec",
  null
  
)

export default component.exports